<script lang="ts">
	import { browser } from '$app/environment';
	import { debounce } from 'lodash-es';
	import { onMount, onDestroy } from 'svelte';

	const MINIMIZE_THRESHOLD = 24;
	const MAXIMIZE_THRESHOLD = 0;
	const DEBOUNCE_DELAY = 10; // milliseconds

	let scrollY: number = 0;
	let isMinimized = false;

	// Function to update `isMinimized` based on the scroll position
	function updateMinimizedState() {
		if (scrollY >= MINIMIZE_THRESHOLD && !isMinimized) {
			isMinimized = true;
		} else if (scrollY <= MAXIMIZE_THRESHOLD && isMinimized) {
			isMinimized = false;
		}
	}

	// Debounced version of the update function
	const debouncedUpdateMinimizedState = debounce(updateMinimizedState, DEBOUNCE_DELAY);

	// Function to handle the actual scroll event
	function handleScroll() {
		scrollY = window.scrollY;
		debouncedUpdateMinimizedState();
	}

	if (browser) {
		onMount(() => {
			window.addEventListener('scroll', handleScroll);
		});

		onDestroy(() => {
			window.removeEventListener('scroll', handleScroll);
			// Cancel any pending debounced calls when the component is destroyed
			debouncedUpdateMinimizedState.cancel();
		});
	}
</script>

<header class="header">
	<div class="header-inner">
		<a href="/" class="">
			<img
				class="logo transition-all inline-block"
				class:minimized={isMinimized}
				src="/icons/telekom-logo.svg"
				alt="Telekom"
			/>
		</a>
	</div>
</header>

<!-- reserve space as big as the fixed element -->
<div class="spacer transition-all" class:minimized={isMinimized}></div>

<!-- <svelte:window bind:scrollY /> -->

<style lang="postcss">
	.header {
		@apply shadow-lpg-tile w-full fixed bg-white px-0 mdheader:px-4 flex xlheader:px-10 items-center z-[1010] xxl:px-0;
	}

	.header-inner {
		/* 94.5rem */
		@apply w-full mx-auto;
		max-width: var(--content-max-width);
	}
	.logo,
	.spacer {
		@apply w-16 h-16 mdheader:w-18 mdheader:h-18 lg:w-20 lg:h-20 xlheader:w-24 xlheader:h-24 xxl:w-30 xxl:h-30;
	}

	.logo.minimized,
	.spacer.minimized {
		@apply w-16 h-16 mdheader:w-18 mdheader:h-18 lg:w-12 lg:h-12 xlheader:w-18 xlheader:h-18;
	}
</style>
